import { z } from 'zod'

export const TrainerSortKeySchema = z.enum([
  'clients',
  'createdAt',
  'email',
  'gender',
  'name',
  'phone',
  'services',
  'status',
])

export const TrainerSortKey = TrainerSortKeySchema.enum

export type TrainerSortKey = z.infer<typeof TrainerSortKeySchema>
